/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.orders.requests.modals.removeOrderRequest.controllers', [])

.controller('OrdersRequestsModalsRemoveOrderRequestController', ['$scope', '$uibModalInstance', 'OrderRequest', function($scope, $uibModalInstance, OrderRequest) {

    $scope.ordersRequestsModalsRemoveOrderRequest = {

      model: {},

      allowDelete: true,

      init: function() {
        if (OrderRequest && OrderRequest.data) {
          this.success.initData();
        } else {
          this.error.initData();
        }

        if (this.model.hasOwnProperty('orderRequestItems') && this.model.orderRequestItems.length){
          this.allowDelete = false;
        }
      },

      done: function() {
        $uibModalInstance.close();
      },

      cancel: function () {
        $uibModalInstance.dismiss('cancel');
      },

      success: {
        init: function(response) {},
        initData: function() {
          $scope.ordersRequestsModalsRemoveOrderRequest.model = OrderRequest.data.payload;
        },
      },

      error: {
        init: function(response) {},
        initData: function() {
          $scope.ordersRequestsModalsRemoveOrderRequest.model = {};
        },
      }

    };

    $scope.ordersRequestsModalsRemoveOrderRequest.init();

}]);
